// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page {
    min-height: 600px;
}

.header-nav {
    width: 100%;
    padding: 20px;
    background: #ffb453;
}

.header-nav ul {
    list-style-type: none;
    list-style: none;
    display: flex;
    padding: 0;
    margin: 0;
}

.home-box {
    padding: 20px 3px !important;
}

.header-nav ul li {
    margin-right: 15px;
}

.header-nav ul li:not(:first-child) {
    margin-left: 25px;
}

.header-nav ul li a {
    text-decoration: none;
    color: #333;
    font-size: 18px;
    font-weight: 500;
}

a.active {
    color: #ffff !important;
}

.align-items-center.py-2.row {
    width: 100%;
}

.row {
    --bs-gutter-x: 0;
}

.kumbh-text h3 {
    margin-top: 10px;
    /* Space between image and heading */
    line-height: 8px;
}

.kumbh-text p {
    margin: 5px 0;
    /* Adjust spacing for the paragraph */
    font-size: 18px;
    font-weight: 500;
}

.tab-content>.active {
    display: contents;
}

.kumbhlogo {
    width: 42%;
    float: left;
    text-align: right;
}

.kumbhtext {
    width: 50%;
    float: left;
    text-align: left;
    margin-top: 13px;
    padding-left: 10px;
}

.tabs-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* border-top: 5px solid orange; */
    padding: 20px 0;
    /* background-color: #f8f8f8; */
}

.tab {
    flex: 1 1;
    display: flex;
    justify-content: center;
    /* Center horizontally */
    align-items: center;
    /* Center vertically */
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: #000000;
    padding: 15px 10px;
    cursor: pointer;
    border-right: 2px solid #9f9d9d;
    min-height: 122px;
}

.tabs-container .tab a {
    color: #000000;
}

.tabs-container .tab:hover a {
    color: #fff;
}

.tab:last-child {
    border-right: none;
}

.tab:hover {
    background-color: #ed5722;
    color: white;
    transition: background 1.5s ease;
}

.tabs-container .active {
    background-color: #ed5722;
    color: white;
}

.footer {
    background-color: #1b9fd6;
}

.footer p {
    color: #fff;
}

.footer .text-center {
    padding-top: 12px;
}

.content-body {
    min-height: 73.5vh;
}

.box {
    padding: 20px;
    margin: 15px 0;
    background-color: #ffffff;
    /* White background */
    border-radius: 8px;
    /* Rounded corners */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    /* Subtle shadow */
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    /* Smooth hover effects */
    margin: 6px;
}

.box:hover {
    transform: translateY(-5px);
    /* Slight lift on hover */
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.2);
    /* Enhanced shadow on hover */
}

/* Container styling */
.content-body {
    background-color: #f9f9f9;
    padding: 30px 20px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Row and Column Styling */
.row {
    /* margin-bottom: 30px; */
}

/* Headings */
.content-body h4 {
    font-size: 1.8rem;
    font-weight: 600;
    color: #343a40;
    margin-bottom: 15px;
    border-left: 5px solid #ffb453;
    padding-left: 10px;
}

/* Paragraphs */
.content-body p {
    font-size: 1.1rem;
    line-height: 1.8;
    color: #495057;
    margin-bottom: 20px;
    text-align: justify;
}

/* Highlight blocks */
.content-body .highlight {
    background-color: #007bff;
    color: #ffffff;
    padding: 10px 15px;
    border-radius: 5px;
    font-weight: 500;
    margin: 20px 0;
    text-align: center;
}

.banner-container img {
    width: 100%;
}

.banner-container {
    padding: 0 !important;
}

.banner {
    position: relative;
    text-align: center;
}

.banner {
    position: relative;
    text-align: center;
}

.banner img {
    width: 100%;
    height: auto;
    opacity: 0.7;
    /* Makes the image semi-transparent */
    transition: opacity 0.5s ease;
    /* Smooth transition on hover */
}

.banner img:hover {
    opacity: 1;
    /* Full opacity on hover */
}

.banner-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: rgba(0, 0, 0, 0.6);
    /* Semi-transparent background for text */
    color: white;
    /* Text color */
    padding: 10px 20px;
    border-radius: 8px;
    font-size: 5rem;
    font-weight: bold;
    text-shadow: 1px 1px 3px rgba(238, 71, 71, 0.5);
}

.kumbhtext h2 {
    font-weight: 700;
    line-height: .5;
    margin-top: 5px;
}




/* Responsive Design */
@media (max-width: 768px) {
    .content-body {
        padding: 20px;
    }

    .content-body h4 {
        font-size: 1.6rem;
    }

    .content-body p {
        font-size: 1rem;
    }
}

.data-box {
    padding: 5px;
    box-shadow: 0px 0px 3px 3px #bbbbbb;
    border-radius: 10px;
    margin: 10px;
}

.data-box p {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: -5px !important;
    color: #1d9ad5;
}

.data-box span {
    font-size: 16px;
    font-weight: 500;
}





.table-container {
    width: 100%;
    /* Makes the container full width */
}

table {
    width: 100%;
    /* Makes the table full width */
    border-collapse: collapse;
    /* Removes space between borders */
}

th,
td {
    border: 1px solid black;
    /* Adds borders to the table cells */
    padding: 8px;
    /* Adds padding inside cells */
    text-align: left;
    /* Aligns text to the left */
}

thead {
    background-color: #f2f2f2;
    /* Light grey background for the header */
}

tr:nth-child(even) {
    background-color: #f9f9f9;
    /* Zebra striping for rows */
}`, "",{"version":3,"sources":["webpack://./src/assets/css/home-style.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;IACb,UAAU;IACV,SAAS;AACb;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kCAAkC;IAClC,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,wBAAwB;IACxB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,wCAAwC;IACxC,kBAAkB;IAClB,qDAAqD;IACrD,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,yCAAyC;IACzC,6BAA6B;AACjC;;AAEA,sBAAsB;AACtB;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA,2BAA2B;AAC3B;IACI,yBAAyB;AAC7B;;AAEA,aAAa;AACb;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA,eAAe;AACf;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,qCAAqC;IACrC,6BAA6B;IAC7B,+BAA+B;AACnC;;AAEA;IACI,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,oCAAoC;IACpC,yCAAyC;IACzC,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,+CAA+C;AACnD;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;;;;AAKA,sBAAsB;AACtB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,YAAY;IACZ,mCAAmC;IACnC,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;;;;;AAMA;IACI,WAAW;IACX,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,+BAA+B;IAC/B,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA;;IAEI,uBAAuB;IACvB,oCAAoC;IACpC,YAAY;IACZ,8BAA8B;IAC9B,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC","sourcesContent":[".home-page {\r\n    min-height: 600px;\r\n}\r\n\r\n.header-nav {\r\n    width: 100%;\r\n    padding: 20px;\r\n    background: #ffb453;\r\n}\r\n\r\n.header-nav ul {\r\n    list-style-type: none;\r\n    list-style: none;\r\n    display: flex;\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n.home-box {\r\n    padding: 20px 3px !important;\r\n}\r\n\r\n.header-nav ul li {\r\n    margin-right: 15px;\r\n}\r\n\r\n.header-nav ul li:not(:first-child) {\r\n    margin-left: 25px;\r\n}\r\n\r\n.header-nav ul li a {\r\n    text-decoration: none;\r\n    color: #333;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n}\r\n\r\na.active {\r\n    color: #ffff !important;\r\n}\r\n\r\n.align-items-center.py-2.row {\r\n    width: 100%;\r\n}\r\n\r\n.row {\r\n    --bs-gutter-x: 0;\r\n}\r\n\r\n.kumbh-text h3 {\r\n    margin-top: 10px;\r\n    /* Space between image and heading */\r\n    line-height: 8px;\r\n}\r\n\r\n.kumbh-text p {\r\n    margin: 5px 0;\r\n    /* Adjust spacing for the paragraph */\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n}\r\n\r\n.tab-content>.active {\r\n    display: contents;\r\n}\r\n\r\n.kumbhlogo {\r\n    width: 42%;\r\n    float: left;\r\n    text-align: right;\r\n}\r\n\r\n.kumbhtext {\r\n    width: 50%;\r\n    float: left;\r\n    text-align: left;\r\n    margin-top: 13px;\r\n    padding-left: 10px;\r\n}\r\n\r\n.tabs-container {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    /* border-top: 5px solid orange; */\r\n    padding: 20px 0;\r\n    /* background-color: #f8f8f8; */\r\n}\r\n\r\n.tab {\r\n    flex: 1 1;\r\n    display: flex;\r\n    justify-content: center;\r\n    /* Center horizontally */\r\n    align-items: center;\r\n    /* Center vertically */\r\n    text-align: center;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    color: #000000;\r\n    padding: 15px 10px;\r\n    cursor: pointer;\r\n    border-right: 2px solid #9f9d9d;\r\n    min-height: 122px;\r\n}\r\n\r\n.tabs-container .tab a {\r\n    color: #000000;\r\n}\r\n\r\n.tabs-container .tab:hover a {\r\n    color: #fff;\r\n}\r\n\r\n.tab:last-child {\r\n    border-right: none;\r\n}\r\n\r\n.tab:hover {\r\n    background-color: #ed5722;\r\n    color: white;\r\n    transition: background 1.5s ease;\r\n}\r\n\r\n.tabs-container .active {\r\n    background-color: #ed5722;\r\n    color: white;\r\n}\r\n\r\n.footer {\r\n    background-color: #1b9fd6;\r\n}\r\n\r\n.footer p {\r\n    color: #fff;\r\n}\r\n\r\n.footer .text-center {\r\n    padding-top: 12px;\r\n}\r\n\r\n.content-body {\r\n    min-height: 73.5vh;\r\n}\r\n\r\n.box {\r\n    padding: 20px;\r\n    margin: 15px 0;\r\n    background-color: #ffffff;\r\n    /* White background */\r\n    border-radius: 8px;\r\n    /* Rounded corners */\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n    /* Subtle shadow */\r\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n    /* Smooth hover effects */\r\n    margin: 6px;\r\n}\r\n\r\n.box:hover {\r\n    transform: translateY(-5px);\r\n    /* Slight lift on hover */\r\n    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.2);\r\n    /* Enhanced shadow on hover */\r\n}\r\n\r\n/* Container styling */\r\n.content-body {\r\n    background-color: #f9f9f9;\r\n    padding: 30px 20px;\r\n    border-radius: 10px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* Row and Column Styling */\r\n.row {\r\n    /* margin-bottom: 30px; */\r\n}\r\n\r\n/* Headings */\r\n.content-body h4 {\r\n    font-size: 1.8rem;\r\n    font-weight: 600;\r\n    color: #343a40;\r\n    margin-bottom: 15px;\r\n    border-left: 5px solid #ffb453;\r\n    padding-left: 10px;\r\n}\r\n\r\n/* Paragraphs */\r\n.content-body p {\r\n    font-size: 1.1rem;\r\n    line-height: 1.8;\r\n    color: #495057;\r\n    margin-bottom: 20px;\r\n    text-align: justify;\r\n}\r\n\r\n/* Highlight blocks */\r\n.content-body .highlight {\r\n    background-color: #007bff;\r\n    color: #ffffff;\r\n    padding: 10px 15px;\r\n    border-radius: 5px;\r\n    font-weight: 500;\r\n    margin: 20px 0;\r\n    text-align: center;\r\n}\r\n\r\n.banner-container img {\r\n    width: 100%;\r\n}\r\n\r\n.banner-container {\r\n    padding: 0 !important;\r\n}\r\n\r\n.banner {\r\n    position: relative;\r\n    text-align: center;\r\n}\r\n\r\n.banner {\r\n    position: relative;\r\n    text-align: center;\r\n}\r\n\r\n.banner img {\r\n    width: 100%;\r\n    height: auto;\r\n    opacity: 0.7;\r\n    /* Makes the image semi-transparent */\r\n    transition: opacity 0.5s ease;\r\n    /* Smooth transition on hover */\r\n}\r\n\r\n.banner img:hover {\r\n    opacity: 1;\r\n    /* Full opacity on hover */\r\n}\r\n\r\n.banner-text {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    background-color: rgba(0, 0, 0, 0.6);\r\n    /* Semi-transparent background for text */\r\n    color: white;\r\n    /* Text color */\r\n    padding: 10px 20px;\r\n    border-radius: 8px;\r\n    font-size: 5rem;\r\n    font-weight: bold;\r\n    text-shadow: 1px 1px 3px rgba(238, 71, 71, 0.5);\r\n}\r\n\r\n.kumbhtext h2 {\r\n    font-weight: 700;\r\n    line-height: .5;\r\n    margin-top: 5px;\r\n}\r\n\r\n\r\n\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n    .content-body {\r\n        padding: 20px;\r\n    }\r\n\r\n    .content-body h4 {\r\n        font-size: 1.6rem;\r\n    }\r\n\r\n    .content-body p {\r\n        font-size: 1rem;\r\n    }\r\n}\r\n\r\n.data-box {\r\n    padding: 5px;\r\n    box-shadow: 0px 0px 3px 3px #bbbbbb;\r\n    border-radius: 10px;\r\n    margin: 10px;\r\n}\r\n\r\n.data-box p {\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    margin-bottom: -5px !important;\r\n    color: #1d9ad5;\r\n}\r\n\r\n.data-box span {\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n.table-container {\r\n    width: 100%;\r\n    /* Makes the container full width */\r\n}\r\n\r\ntable {\r\n    width: 100%;\r\n    /* Makes the table full width */\r\n    border-collapse: collapse;\r\n    /* Removes space between borders */\r\n}\r\n\r\nth,\r\ntd {\r\n    border: 1px solid black;\r\n    /* Adds borders to the table cells */\r\n    padding: 8px;\r\n    /* Adds padding inside cells */\r\n    text-align: left;\r\n    /* Aligns text to the left */\r\n}\r\n\r\nthead {\r\n    background-color: #f2f2f2;\r\n    /* Light grey background for the header */\r\n}\r\n\r\ntr:nth-child(even) {\r\n    background-color: #f9f9f9;\r\n    /* Zebra striping for rows */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
